import { Injectable } from '@angular/core';
import { DepotStockLocation } from '../models/depot-stock-location.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepotStockLocationService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getDepotStockLocationById(id: number): Observable<DepotStockLocation> {

    if(id <= 0 || id === null || id === undefined) {
      throw new Error('DepotStockLocationService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'depot-stock-location/' + id).pipe(map((value: any) => {
      return <DepotStockLocation>value;
    }));
  }

  createDepotStockLocation(location: DepotStockLocation): Observable<DepotStockLocation> {

    if(!location) {
      throw new Error('depot stock location service: you must supply a depot stock location object for saving');
    }

    delete location.createdAt;
    delete location.updatedAt;

    if(location.id > 0) {
      throw new Error('depot stock location service: Cannot create an existing object');
    }

    delete location.id;
    return this.httpClient.post(this._endpoint + 'depot-stock-location',
    JSON.stringify(location),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <DepotStockLocation>data;
    }));
  }

  updateDepotStockLocation(location: DepotStockLocation): Observable<DepotStockLocation> {

    if(!location) {
      throw new Error('depot stock location service: you must supply a depot stock location object for saving');
    }

    delete location.createdAt;
    delete location.updatedAt;

    if(!location.id || location.id === -1) {
      throw new Error('depot stock location service: Cannot update a record without id');
    }

    return this.httpClient.put(this._endpoint + 'depot-stock-location/' + location.id,
    JSON.stringify(location),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <DepotStockLocation>data;
    }));
  }
}
